import { CustomerContactListPage, VendorContactListPage } from 'contacts/pages';

import { customerContactListPath, vendorContactListPath } from './routePaths';

export const customerContacts = {
  path: customerContactListPath(),
  exact: true,
  isPrivate: true,
  element: <CustomerContactListPage />,
};

export const vendorContacts = {
  path: vendorContactListPath(),
  exact: true,
  isPrivate: true,
  element: <VendorContactListPage />,
};
